import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { DEFAULT_FILL_OPACITY, ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const RadioButtonFilledIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  fillOpacity = DEFAULT_FILL_OPACITY,
}) => (
  <SvgWrapper aria-label="Filled radio button" viewBox={viewBox} size={size} fill="none">
    <rect x="2" y="2" width="20" height="20" rx="10" fill={color} fillOpacity={fillOpacity} />
    <rect x="8" y="8" width="8" height="8" rx="4" fill="white" />
  </SvgWrapper>
)

export default RadioButtonFilledIcon
